import { useContext, useEffect, useState } from "react";
import { Box, Button, Grid, Modal, Typography } from "@mui/material";
import { SidebarContext } from "../../../../contexts/SidebarContext";
import { GCAutocomplete } from "../../../../shared/components/autoComplete";
import { getLocalStorageData } from "../../../../shared/utils/localStorage";
import useLazyQuery from "../../../../shared/components/hooks/useLazyQuery";
import useQuery from "../../../../shared/components/hooks/useQuery";


interface SwitchOrganizationProps {
    open: boolean;
    onClose: () => void;
    onConfirm: (orgID: string | null,  orgDetails: any) => void;
    currentOrg: any;
    title: string;
    message: string;
    organizationData: any[];
    organizationLoading: boolean;
}

const SwitchOrganization: React.FC<SwitchOrganizationProps> = ({ open, onClose, title, message, onConfirm, currentOrg, organizationData, organizationLoading }) => {

    const [selectedOrg, setSelectedOrg] = useState<{ orgID: string | null; orgName: string | null }>({
        // orgID: null,
        // orgName: null,
        orgID: currentOrg?.id || null,
        orgName: currentOrg?.name || null,
    });

    const { payload, setPayload } = useContext(SidebarContext);



    const localStorageData = getLocalStorageData("userData");



    const orgs = Array.isArray(organizationData)
        ? organizationData
            .filter((orgData: any) => orgData && (orgData.id != localStorageData?.orgID))
            .map((orgData: any) => ({
                label: orgData.name,
                value: orgData.id,
            }))
        : [];

    const filteredOrgs = orgs?.filter((org: any) => org?.value !== currentOrg?.id);

    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 400,
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                }}
            >
                <Typography variant="h5" gutterBottom>
                    {title}
                </Typography>
                <Typography variant="body1" sx={{ mb: 2, fontSize: "15px", mt: 2 }}>
                    {message}
                </Typography>

                <Grid item >
                    <GCAutocomplete
                        options={filteredOrgs}
                        // label="Organization"
                        size="small"
                        placeholder="Select Organization"
                        required={false}
                        loading={organizationLoading}
                        onChange={(selectedOption: any) => {
                            setSelectedOrg({
                                orgID: selectedOption?.value || null,
                                orgName: selectedOption?.label || null,
                            });
                        }}
                        value={orgs?.find((org: any) => org?.value === selectedOrg.orgID) || null}
                        refetchFunction={(searchString: string) => {
                            setPayload((prevData: any) => ({
                                ...prevData,
                                search: searchString,
                            }));
                        }}
                    />
                </Grid>

                <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, marginTop: "20px" }}>
                    <Button variant="outlined" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button variant="contained" color="primary"
                        onClick={() => {
                            if (localStorage.getItem('switchingOrgs') === null) {
                                organizationData.push(localStorageData?.employee?.organization)
                                localStorage.setItem('switchingOrgs', JSON.stringify(organizationData));
                            }
                            onConfirm(selectedOrg?.orgID, selectedOrg);
                            onClose();
                        }}
                        disabled={!selectedOrg?.orgID}
                    >
                        Confirm
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default SwitchOrganization;
